import { render, staticRenderFns } from "./Tiptap.vue?vue&type=template&id=63b54065&scoped=true"
import script from "./Tiptap.vue?vue&type=script&lang=js"
export * from "./Tiptap.vue?vue&type=script&lang=js"
import style0 from "./Tiptap.vue?vue&type=style&index=0&id=63b54065&prod&scoped=true&lang=css"
import style1 from "./Tiptap.vue?vue&type=style&index=1&id=63b54065&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b54065",
  null
  
)

export default component.exports